import {
  dateToExcelSerial,
  CellType,
} from '../../../../../utils/spreadsheet/utils'

/**
 * Definições das tabelas da planilha de faturamento.
 * Adicionado campo 'metadata' para identificar campos importantes para extração.
 */

export const contractItemsTableDef = {
  title: 'ITENS DO CONTRATO',
  titleStyle: 'sectionTitle',
  headerStyle: 'header',
  columns: [
    {
      key: 'alias',
      label: 'ITEM',
      width: 220,
      style: 'locked',
      locked: true,
      metadata: { type: 'contract_item', field: 'item_code' },
    },
    {
      key: 'description',
      label: 'MODELO',
      width: 280,
      style: 'locked',
      locked: true,
      metadata: { type: 'contract_item', field: 'description' },
    },
    {
      key: 'quantity',
      label: 'QUANTIDADE',
      width: 110,
      style: 'lockedNumber',
      locked: true,
      metadata: { type: 'contract_item', field: 'quantity' },
    },
    {
      key: 'price',
      label: 'R$ UNIT',
      width: 130,
      style: 'editableCurrency',
      metadata: { type: 'contract_item', field: 'price' },
    },
    {
      label: 'TOTAL',
      width: 140,
      formula: '=C{row}*D{row}',
      style: 'lockedCurrency',
      locked: true,
      // Não precisa de metadata pois é calculado
    },
    {
      key: 'available_quantity',
      label: 'SALDO',
      width: 110,
      styleFn: (item) =>
        item.available_quantity < 0 ? 'negativeNumber' : 'positiveNumber',
      locked: true,
      metadata: { type: 'contract_item', field: 'available_quantity' },
    },
  ],
  totals: [
    {
      labelColIndex: 3,
      label: 'TOTAL GERAL:',
      labelStyle: 'totalLabel',
      colIndex: 4,
      formula: '=SUM(E{dataStart}:E{dataEnd})',
      style: 'totalCurrency',
      locked: true,
    },
  ],
  mergeCells: [{ startRow: 0, startCol: 0, endRow: 0, endCol: 5 }],
}

export const contractServicesTableDef = {
  title: 'SERVIÇOS DO CONTRATO',
  titleStyle: 'sectionTitle',
  headerStyle: 'header',
  columns: [
    { key: 'id', label: 'ID', width: 70, style: 'lockedNumber', locked: true, metadata: { type: 'contract_service', field: 'id' } },
    { key: 'alias', label: 'SERVIÇO', width: 220, style: 'locked', locked: true, metadata: { type: 'contract_service', field: 'alias' } },
    { key: 'description', label: 'DESCRIÇÃO', width: 250, style: 'locked', locked: true, metadata: { type: 'contract_service', field: 'description' } },
    { key: 'quantity', label: 'QUANTIDADE CONTRATADA', width: 150, style: 'lockedNumber', locked: true, metadata: { type: 'contract_service', field: 'quantity' } },
    { key: 'price', label: 'PREÇO UNIT.', width: 130, style: 'lockedCurrency', locked: true, metadata: { type: 'contract_service', field: 'price' } },
  ],
  mergeCells: [{ startRow: 0, startCol: 0, endRow: 0, endCol: 4 }],
}

export const billedContractServicesTableDef = {
  title: 'SERVIÇOS FATURADOS',
  titleStyle: 'sectionTitle',
  headerStyle: 'header',
  columns: [
    { key: 'service_id', label: 'ID', width: 70, style: 'lockedNumber', locked: true, metadata: { type: 'billed_contract_service', field: 'service_id' } },
    { key: 'alias', label: 'SERVIÇO', width: 220, style: 'locked', locked: true, metadata: { type: 'billed_contract_service', field: 'alias' } },
    { key: 'description', label: 'DESCRIÇÃO', width: 250, style: 'locked', locked: true, metadata: { type: 'billed_contract_service', field: 'description' } },
    { key: 'quantity', label: 'QUANTIDADE FATURADA', width: 150, style: 'editableNumber', locked: false, metadata: { type: 'billed_contract_service', field: 'quantity' } },
    { key: 'price', label: 'PREÇO UNIT.', width: 130, style: 'lockedCurrency', locked: true, metadata: { type: 'billed_contract_service', field: 'price' } },
    { label: 'TOTAL', width: 140, formula: '=Q{row}*R{row}', style: 'lockedCurrency', locked: true },
  ],
  totals: [
    { labelColIndex: 4, label: 'TOTAL SERVIÇOS:', labelStyle: 'totalLabel', colIndex: 5, formula: '=SUM(S{dataStart}:S{dataEnd})', style: 'totalCurrency', locked: true },
  ],
  mergeCells: [{ startRow: 0, startCol: 0, endRow: 0, endCol: 5 }],
}

export const excessContractServicesTableDef = {
  title: 'EXCEDENTES DE SERVIÇOS',
  titleStyle: 'exchangeSectionTitle',
  headerStyle: 'exchangeHeader',
  columns: [
    { key: 'service_id', label: 'ID', width: 70, style: 'lockedNumber', locked: true, metadata: { type: 'excess_contract_service', field: 'service_id' } },
    { key: 'alias', label: 'SERVIÇO', width: 220, style: 'locked', locked: true, metadata: { type: 'excess_contract_service', field: 'alias' } },
    { key: 'description', label: 'DESCRIÇÃO', width: 250, style: 'locked', locked: true, metadata: { type: 'excess_contract_service', field: 'description' } },
    { key: 'quantity', label: 'QUANTIDADE EXCEDENTE', width: 150, style: 'lockedNumber', locked: true, metadata: { type: 'excess_contract_service', field: 'quantity' } },
    { key: 'price', label: 'PREÇO UNIT.', width: 130, style: 'lockedCurrency', locked: true, metadata: { type: 'excess_contract_service', field: 'price' } },
    { label: 'TOTAL EXCEDENTE', width: 140, formula: '=Q{row}*R{row}', style: 'exchangeTotalCurrency', locked: true },
  ],
  totals: [
    { labelColIndex: 4, label: 'TOTAL EXCEDENTE:', labelStyle: 'totalLabel', colIndex: 5, formula: '=SUM(S{dataStart}:S{dataEnd})', style: 'exchangeTotalCurrency', locked: true },
  ],
  mergeCells: [{ startRow: 0, startCol: 0, endRow: 0, endCol: 5 }],
}

export const getRentedEquipmentsTableDef = (billType) => {
  const isSeparate = billType === 'separate'

  // Lógica de colunas do Excel:
  // Se for 'separate', a tabela começa na coluna E (índice 4).
  // Colunas: E(Tipo), F(Qtd), G(Preço), H(Total). Fórmula: F*G, Soma: H
  // Se for 'by_contract', a tabela começa na coluna H (índice 7).
  // Colunas: H(Tipo), I(Qtd), J(Preço), K(Total). Fórmula: I*J, Soma: K

  const colQtd = isSeparate ? 'F' : 'I'
  const colPreco = isSeparate ? 'G' : 'J'
  const colTotal = isSeparate ? 'H' : 'K'

  return {
    title: 'TIPOS ALUGADOS',
    titleStyle: 'sectionTitle',
    headerStyle: 'header',
    columns: [
      {
        key: 'tipo_equipamento',
        label: 'TIPO',
        width: 280,
        style: 'locked',
        locked: true,
        metadata: { type: 'rented_equipment', field: 'tipo_equipamento' },
      },
      {
        key: 'quantidade',
        label: 'QUANTIDADE',
        width: 130,
        style: 'lockedNumber',
        locked: true,
        metadata: { type: 'rented_equipment', field: 'quantidade' },
      },
      {
        key: 'preco_unitario',
        label: 'PREÇO UNIT.',
        width: 140,
        style: 'editableCurrency',
        metadata: { type: 'rented_equipment', field: 'preco_unitario' },
      },
      {
        label: 'TOTAL',
        width: 140,
        formula: `=${colQtd}{row}*${colPreco}{row}`,
        style: 'lockedCurrency',
        locked: true,
      },
    ],
    totals: [
      {
        labelColIndex: 2,
        label: 'TOTAL:',
        labelStyle: 'totalLabel',
        colIndex: 3,
        formula: `=SUM(${colTotal}{dataStart}:${colTotal}{dataEnd})`,
        style: 'totalCurrency',
        locked: true,
      },
    ],
    mergeCells: [{ startRow: 0, startCol: 0, endRow: 0, endCol: 3 }],
  }
}

export const getExchangeRentedEquipmentsTableDef = (startColIndex = 7) => {
  // Quando startColIndex = 7 (Coluna H):
  // Col 0 (Tipo) = H (7)
  // Col 1 (Qtd) = I (8)
  // Col 2 (Preço) = J (9)
  // Col 3 (Total) = K (10)

  const colQtd = String.fromCharCode(65 + startColIndex + 1)
  const colPreco = String.fromCharCode(65 + startColIndex + 2)
  const colTotal = String.fromCharCode(65 + startColIndex + 3)

  return {
    title: 'EXCEDENTES DO CONTRATO',
    titleStyle: 'exchangeSectionTitle',
    headerStyle: 'exchangeHeader',
    columns: [
      {
        key: 'tipo_equipamento',
        label: 'TIPO',
        width: 280,
        style: 'locked',
        locked: true,
        metadata: { type: 'exchange_equipment', field: 'tipo_equipamento' },
      },
      {
        key: 'quantidade',
        label: 'QUANTIDADE',
        width: 130,
        style: 'lockedNumber',
        locked: true,
        metadata: { type: 'exchange_equipment', field: 'quantidade' },
      },
      {
        key: 'preco_unitario',
        label: 'PREÇO UNIT.',
        width: 140,
        style: 'editableCurrency',
        metadata: { type: 'exchange_equipment', field: 'preco_unitario' },
      },
      {
        label: 'TOTAL',
        width: 140,
        formula: `=${colQtd}{row}*${colPreco}{row}`,
        style: 'exchangeTotalCurrency',
        locked: true,
      },
    ],
    totals: [
      {
        labelColIndex: 2,
        label: 'TOTAL EXCEDENTE:',
        labelStyle: 'totalLabel',
        colIndex: 3,
        formula: `=SUM(${colTotal}{dataStart}:${colTotal}{dataEnd})`,
        style: 'exchangeTotalCurrency',
        locked: true,
      },
    ],
    mergeCells: [{ startRow: 0, startCol: 0, endRow: 0, endCol: 3 }],
  }
}

export const equipmentsDetailsTableDef = {
  title: 'DETALHES DOS EQUIPAMENTOS',
  titleStyle: 'sectionTitle',
  headerStyle: 'header',
  columns: [
    {
      key: 'description',
      label: 'DESCRIÇÃO',
      width: 320,
      style: 'locked',
      locked: true,
      metadata: { type: 'equipment_detail', field: 'description' },
    },
    {
      key: 'situation',
      label: 'SITUAÇÃO',
      width: 130,
      styleFn: (item) => {
        const s = (item.situation || '').toUpperCase()
        if (s.includes('ALUGAD')) return 'statusRented'
        if (s.includes('RESERV')) return 'statusReserved'
        if (s.includes('DEVOL') || s.includes('DISPON')) return 'statusReturned'
        return 'locked'
      },
      metadata: { type: 'equipment_detail', field: 'situation' },
    },
    {
      key: 'movement_date',
      label: 'DATA DO MOVIMENTO',
      width: 160,
      style: 'lockedDate',
      type: CellType.NUMBER,
      valueFn: (item) => dateToExcelSerial(item.movement_date),
      locked: true,
      metadata: { type: 'equipment_detail', field: 'movement_date' },
    },
  ],
  mergeCells: [{ startRow: 0, startCol: 0, endRow: 0, endCol: 2 }],
}
